import { Service } from '@magicdoorinc/env';
import { createFileService, FileUrlVariant, type FileService, type FileUrlDescriptor } from '@magicdoorinc/file';
import type { FileUrls } from '~/use-cases/types/FileUrls';
import { getEnvConfig } from '~/utils/env';
import { Gateway } from './base/gateway';
import { baseNetworkManager } from './network/baseNetworkManager';

class FileGateway extends Gateway {
  private fileService?: FileService;

  public getFileService = (): FileService => {
    if (!this.fileService) {
      this.fileService = createFileService({ baseUrl: getEnvConfig().service[Service.Files] });
    }
    return this.fileService;
  };

  public fileUrlsOf = (descriptor?: FileUrlDescriptor): FileUrls | undefined => {
    if (!descriptor) return undefined;
    const service = this.getFileService();
    return {
      thumbUrl: service.buildUrlFromDescriptor(descriptor, FileUrlVariant.Thumb),
      previewUrl: service.buildUrlFromDescriptor(descriptor, FileUrlVariant.Preview),
      rawUrl: service.buildUrlFromDescriptor(descriptor, FileUrlVariant.Original),
      downloadUrl: service.buildUrlFromDescriptor(descriptor, FileUrlVariant.Download),
    };
  };
}

export const fileGateway = new FileGateway(baseNetworkManager);
